import React from "react";
import { useState, useEffect } from "react";
import { CalendarIcon } from "@heroicons/react/24/outline";
import WorkflowSection from "../section/WorkflowSection";
import TodaysAppointments from "../section/TodaysAppointments";
import BusinessPerformance from "../section/BusinessPerformance";
import RecentUsers from "../section/RecentUsers";
import { getUserRole } from "../../utils/permissions";
import { ShieldAlert  } from "lucide-react";
export default function Dashboard() {
    const [userName, setUserName] = useState("");
    const today = new Date();
    const dayName = today.toLocaleDateString("en-US", { weekday: "long" });
    const monthDay = today.toLocaleDateString("en-US", { month: "long", day: "numeric" });

    useEffect(() => {
        const storedUser = localStorage.getItem("user_data");
        if (storedUser) {
            const user = JSON.parse(storedUser);
            setUserName(user.name);
        }
    }, []);

    const userRole = getUserRole();
    const isRestricted = userRole !== 'company';

    return (
        <section className="relative space-y-8 min-h-[calc(100vh-150px)]">
            {/* Access Denied Overlay */}
            {isRestricted && (
                <div className="absolute inset-0 z-[50] backdrop-blur-md bg-white/40 flex items-center justify-center p-4 sm:p-6 animate-in fade-in duration-500 rounded-3xl">
                    <div className="bg-white rounded-[2.5rem] shadow-2xl border border-gray-100 max-w-md w-full p-8 text-center relative overflow-hidden ring-1 ring-black/5">
                        {/* Decorative Background */}
                        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-500 via-orange-500 to-amber-500" />
                        <div className="absolute -top-12 -right-12 w-32 h-32 bg-red-50 rounded-full blur-3xl opacity-60" />

                        <div className="relative">
                            <div className="w-20 h-20 bg-red-50 rounded-3xl flex items-center justify-center mx-auto mb-6 transform -rotate-6 transition-transform hover:rotate-0 duration-300 shadow-sm border border-red-100">
                                <ShieldAlert className="w-10 h-10 text-red-600" />
                            </div>

                            <h2 className="text-3xl font-black text-gray-900 tracking-tight mb-3">Access Denied</h2>
                            <p className="text-gray-500 font-medium leading-relaxed mb-8">
                                The main dashboard is restricted to <span className="text-red-600 font-bold uppercase tracking-wider text-xs">Company Admins</span> only.
                                Please use the sidebar to access your assigned tasks and features.
                            </p>
                        </div>
                    </div>
                </div>
            )}

            <div className={`space-y-6 transition-all duration-700 ${isRestricted ? 'blur-sm grayscale opacity-50 pointer-events-none' : ''}`}>
                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                        <div>
                            <p className="text-lg text-gray-600 flex items-center gap-2">
                                <CalendarIcon className="w-5 h-5" />
                                {dayName}, {monthDay}
                            </p>
                            <h1 className="text-3xl font-bold text-gray-900 mt-1">
                                Good morning, {userName}
                            </h1>
                        </div>
                    </div>
                </div>

                <WorkflowSection />

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <TodaysAppointments />
                    <BusinessPerformance />
                </div>

                <RecentUsers />
            </div>
        </section>
    );
}